module.exports = __webpack_public_path__ + "static/media/buy_req_rent_11.1205609c.png";